import { actionTypes, initialState } from "./user.constant";

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ON_USER_LOADING: {
      return {
        ...state,
        loginLoading: true,
      };
    }
    case actionTypes.ON_USER_DATA: {
      return {
        ...state,
        userLoading: false,
        users: [...action.payload.data],
        count: action.payload.count,
        total: action.payload.total,
      };
    }

    case actionTypes.ON_QUERY_USER_DATA: {
      return {
        ...state,
        userLoading: false,
        users: action.payload.data,
        count: action.payload.count,
        total: action.payload.count,
      };
    }
    case actionTypes.ON_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        userError: action.payload,
      };
    }
    case actionTypes.ON_DELETE_USER_LOADING: {
      return {
        ...state,
        userDeleteLoading: true,
      };
    }
    case actionTypes.ON_DELETE_USER_SUCCESS: {
      return {
        ...state,
        userDeleteLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
